var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comment-like-button mr-3"},[_c('a',{staticClass:"small",class:{active: _vm.liked},on:{"click":_vm.toggleLike}},[_vm._v("\n        Like\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }